export const FULL_TEXT = 'fulltext';
